import { api, API_PREFIX, withFallback } from './client'
import { LEGACY_FEATURE_KEYS, type FeatureFlags } from '../../types/api'

/** Defaults used when GET /features does not exist yet: legacy surfaces on. */
export const DEFAULT_FEATURES: FeatureFlags = Object.fromEntries(LEGACY_FEATURE_KEYS.map(k => [k, true]))

/** GET /features → { [key]: boolean } (new) */
export async function getFeatures(): Promise<FeatureFlags> {
  return withFallback(async () => {
    const res = await api.get<FeatureFlags>(`${API_PREFIX}/features`)
    return { ...DEFAULT_FEATURES, ...(res.data ?? {}) }
  }, DEFAULT_FEATURES)
}
